/**
 * Вычисляет разницу во времени между переданной датой и текущим моментом
 * и возвращает её в формате "Xч Yм".
 *
 * Функция возвращает абсолютную разницу времени и не учитывает,
 * находится ли переданная дата в будущем или уже прошла.
 * Для определения просрочки нужно отдельно сравнить timestamp даты и текущего времени.
 *
 * @param date - Дата и время в строковом формате (обычно ISO/UTC, например "2026-03-12T10:30:00Z").
 * @param now - Текущий timestamp в миллисекундах (обычно передаётся результат Date.now()).
 *
 * @returns Строка с разницей во времени в формате "{часы}ч {минуты}м".
 *
 * @example
 * const now = Date.now();
 * diffTime("2026-03-12T12:30:00Z", now);
 * // "2ч 15м"
 *
 * @example
 * const now = Date.now();
 * diffTime("2026-03-12T08:00:00Z", now);
 * // "1ч 10м" (дата уже прошла, но функция возвращает абсолютную разницу)
 */
type DiffTimeOptions = {
  compact?: boolean;
};

export const diffTime = (date: string, now: number, options?: DiffTimeOptions) => {
  const { compact = true } = options || {};

  const diff = new Date(date).getTime() - now;

  const minutes = Math.abs(Math.floor(diff / 60000));

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  if (compact) {
    if (h >= 48) return `${Math.floor(h / 24)}д`;
    if (h >= 24) return `${h}ч`;
  }

  return `${h ? h + 'ч ' : ''}${m ? m + 'м' : h ? '' : '<1м'}`;
};
